// src/components/SubscribeForm.jsx
import { useState } from 'react';
import { collection, addDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export default function SubscribeForm({ source = 'footer', variant = 'dark' }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'success' | 'error' | 'duplicate'
  const [loading, setLoading] = useState(false);

  const isDark = variant === 'dark';
  const inputStyle = {
    flex: 1,
    height: '40px',
    padding: '8px 16px',
    borderRadius: '8px',
    border: isDark ? '1px solid rgba(255,255,255,0.2)' : '1px solid var(--shades-400)',
    background: isDark ? 'rgba(255,255,255,0.08)' : '#fff',
    color: isDark ? '#fff' : 'var(--token-title)',
    fontFamily: 'var(--font-family)',
    fontSize: '15px',
    outline: 'none',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) return;
    setLoading(true);
    setStatus(null);
    try {
      // Check for duplicate
      const q = query(collection(db, 'subscribers'), where('email', '==', trimmed));
      const snap = await getDocs(q);
      if (!snap.empty) {
        setStatus('duplicate');
        setLoading(false);
        return;
      }
      await addDoc(collection(db, 'subscribers'), {
        email: trimmed,
        subscribedAt: serverTimestamp(),
        source,
      });
      setStatus('success');
      setEmail('');
    } catch (err) {
      console.error(err);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {status === 'success' ? (
        <p style={{ color: isDark ? '#86efac' : '#16a34a', fontSize: '14px' }}>
          You're subscribed! We'll send updates to your inbox.
        </p>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <input
            type="email"
            required
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
          />
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ height: '40px', padding: '8px 20px', flexShrink: 0 }}
          >
            {loading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
      )}
      {status === 'duplicate' && (
        <p style={{ color: isDark ? '#fcd34d' : '#d97706', fontSize: '13px', marginTop: '6px' }}>
          This email is already subscribed.
        </p>
      )}
      {status === 'error' && (
        <p style={{ color: '#f87171', fontSize: '13px', marginTop: '6px' }}>
          Something went wrong. Please try again.
        </p>
      )}
    </div>
  );
}